import { URI_ACCOUNTING_CASH } from '@/config/config';

export default async ({ rootState }, { accountingCashId }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await fetch(
    `${URI_ACCOUNTING_CASH}open/general/${accountingCashId}`,
    opts,
  );
  const jsonResult = await response.json();
  if (jsonResult.error) {
    return Promise.reject(jsonResult.error);
  }
  return jsonResult;
};
